import {gql, InMemoryCache, makeVar, ReactiveVar} from '@apollo/client';

import {makeVarPersisted} from "@betrue/shared/utils";


const msgInitialValue = 'Hello and welcome using graphql'


export const msgVar = makeVarPersisted<string>(msgInitialValue,'msgVar')

export const GET_LAST_MESSAGE = gql`
  query GetLastMessage {
    msg @client
  }
`;

export const msgStore = {
  msg: {
    read() {
      return msgVar()
    },

  }
}

export const updateMsg = (text: string) => {
  msgVar(text)
}
